import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Info } from 'lucide-react';

const TeachingTooltip = ({
  whatThis,
  tryThis,
  whyMatters,
  connectedTo,
  children,
  side = 'top',
  showIcon = false,
}) => (
  <TooltipProvider delayDuration={300}>
    <Tooltip>
      <TooltipTrigger asChild>
        {showIcon ? (
          <button
            type="button"
            className="inline-flex items-center justify-center text-slate-400 hover:text-teal-600 dark:hover:text-teal-400 transition-colors ml-1 align-middle"
            aria-label="Show tooltip"
          >
            <Info className="h-3.5 w-3.5" />
          </button>
        ) : (
          children
        )}
      </TooltipTrigger>
      <TooltipContent
        side={side}
        sideOffset={8}
        className="max-w-xs p-0 bg-transparent border-0 shadow-none z-50"
      >
        <div className="bg-slate-900 dark:bg-slate-800 text-slate-50 border border-slate-700 shadow-2xl rounded-lg p-4 space-y-2.5 text-xs leading-relaxed">
          <div>
            <span className="font-semibold text-teal-400">What this is: </span>
            <span className="text-slate-300">{whatThis}</span>
          </div>
          <div>
            <span className="font-semibold text-amber-400">Try this: </span>
            <span className="text-slate-300">{tryThis}</span>
          </div>
          <div>
            <span className="font-semibold text-sky-400">Why it matters: </span>
            <span className="text-slate-300">{whyMatters}</span>
          </div>
          <div>
            <span className="font-semibold text-purple-400">Connected to: </span>
            <span className="text-slate-400">{connectedTo}</span>
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default TeachingTooltip;
